/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsAccountType204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsAccountType505Schema = z.any();

export const optionsAccountTypeMutationResponseSchema = z.lazy(() => optionsAccountType204Schema);
